import { Filter } from "react-feather";
import { Link } from "react-router-dom";
import { Href } from "../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { setFilterToggle } from "../../../../ReduxToolkit/Reducers/ECommerce/ProductSlice";

export const ProductListFilterHeader = ({ButtonName}:{ButtonName:string}) => {
  const { filterToggle } = useAppSelector((state) => state.product);
  const dispatch = useAppDispatch();

  return (
    <div>
      <div className="light-box" onClick={() => dispatch(setFilterToggle())}>
        <a href={Href}>
          <Filter className={`filter-icon ${filterToggle ? "hide" : "show"}`} />
          <i className={`icon-close filter-close ${filterToggle ? "show" : "hide"}`} />
        </a>
      </div>
      <Link className="btn btn-primary" to={`${process.env.PUBLIC_URL}/applications/ecommerce/add_products`}>
        <i className="fa fa-plus" />
        {ButtonName}
      </Link>
    </div>
  );
};
